import { useFormikContext } from "formik";
import React, { FC } from "react";
import { REPORTS_FILTER_DATE_TIME_DATE_RANGE, REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE } from "../../../constants/element-type";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { getFormattedDate } from "../../../services/utilities/dateFormatting";
import { convertDateToNumber } from "../../../utilities/DateUtils";
import { WizardSummaryLayout } from '../../wizard/wizard-summary-layout';

interface SummaryProps {
    onBack: (event: any) => void;
    type: any,
    category: any
}

export const Summary: FC<SummaryProps> = ({ onBack, type, category }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    const getDateDetails = () => {
        let date: string = "";
        if (values.startDate && values.endDate && values.categoryElementSysname !== REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE) {
            date = getFormattedDate(convertDateToNumber(values.startDate).toString()) + " - " + getFormattedDate(convertDateToNumber(values.endDate).toString())
        }
        else if (values.startDate) {
            date = getFormattedDate(convertDateToNumber(values.startDate).toString());
        }

        return <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.details)}: <span className="text-sm text-black">{date}</span></h4>
    }

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.filter)}: <span className="text-sm text-black">{type}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.category)}: <span className="text-sm text-black">{category}</span></h4>
        {values.categoryElementSysname === REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE || values.categoryElementSysname === REPORTS_FILTER_DATE_TIME_DATE_RANGE ? getDateDetails() : null}
    </WizardSummaryLayout>
}
